@if (!user) {
  <svg ftrIcon="AccountCircle" [iconSize]="size" iconColor="Grey40" class="align-sub"></svg>
}

@if (user) {
  <div class="user-avatar" [ngClass]="'user-avatar--' + color" [style.--avatar-size]="sizePx + 'px'">
    {{ userInitials ?? '' | uppercase }}
  </div>
}
